import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, useTheme } from '@mui/material';
import { FaFilter } from 'react-icons/fa';
import dayjs, { Dayjs } from 'dayjs';
import { Grid } from "@material-ui/core";
import useGlobalContext from "../../Hooks/useGlobalContext";
import getInitialDataFilter from "./initialDataFilter";
import { IFilter } from "./types";

const primaryColor = '#1c2e4a';

const EstruturaMercadologicaPageFilter: React.FC = () => {
    const theme = useTheme(); // 👈 suporte ao tema claro/escuro

    const { filters, setFilters, showFilters, setShowFilters } = useGlobalContext();

    const [initialDate, setInitialDate] = useState<Dayjs | null>(dayjs(filters?.startDate || undefined));
    const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | null>(dayjs(filters?.endDate || undefined));
    
    const [codigo_plu, setCodigoPlu] = useState<string>(filters?.codigo_plu || '');
    const [descricao_completa, setDescricaoCompleta] = useState<string>(filters?.descricao_completa || '');
    const [descricao_secao, setSecao] = useState<string>(filters?.descricao_secao || '');
    const [descricao_grupo, setGrupo] = useState<string>(filters?.descricao_grupo || '');
    const [descricao_sub_grupo, setSubGrupo] = useState<string>(filters?.descricao_sub_grupo || '');

    const [selectedButton, setSelectedButton] = useState('');
    const [loading, setLoading] = useState(false);

    const runFilters = () => {
        setFilters?.((prev) => ({
            ...prev,
            startDate: initialDate?.format('YYYY-MM-DD') || '',
            endDate: selectedEndDate?.format('YYYY-MM-DD') || '',
            establishment: '',
            codigo_plu: codigo_plu || '',
            descricao_completa: descricao_completa || '',
            descricao_secao: descricao_secao || '',
            descricao_grupo: descricao_grupo || '',
            descricao_sub_grupo: descricao_sub_grupo || ''
        }));
    };

    const clearFilters = () => {
        setFilters?.(getInitialDataFilter());
        setCodigoPlu('');
        setDescricaoCompleta('');
        setSecao('');
        setGrupo('');
        setSubGrupo('');
    };

    const isToday = (date: string) => {
        const today = dayjs();
        const givenDate = dayjs(date);
        return givenDate.isSame(today, 'day');
    };

    useEffect(() => {
        if (initialDate && selectedEndDate && isToday(selectedEndDate.format('YYYY-MM-DD'))) {
            const days = selectedEndDate.diff(initialDate, 'day');
            setSelectedButton((days + 1).toString());
        } else {
            setSelectedButton('0');
        }
    }, [initialDate, selectedEndDate]);

    useEffect(() => {
        if (filters?.startDate) setInitialDate(dayjs(filters.startDate));
        if (filters?.endDate) setSelectedEndDate(dayjs(filters.endDate));
    }, [filters]);

    return (
        <Grid item xs={12} md={12} lg={12}>
            <Box sx={{ backgroundColor: theme.palette.background.paper }} p={1}>
                <Grid item xs={12}>
                    <Button onClick={() => setShowFilters?.(prev => !prev)}>
                        <span style={{ marginRight: '10px' }}><FaFilter /></span>
                        {showFilters ? 'Esconder Filtros' : 'Mostrar Filtros'}
                    </Button>
                </Grid>
                {showFilters && (
                    <Grid item xs={12} style={{ marginTop: 2 }} component="section">
                        <Grid container spacing={2} style={{ maxWidth: '100%' }}>
                            <Grid item xs={12} sm={3} md={2} lg={2}>
                                <TextField
                                    label="CÓDIGO PLU"
                                    disabled={loading}
                                    variant="outlined"
                                    value={codigo_plu}
                                    onChange={e => setCodigoPlu(e.target.value)}
                                    onClick={() => setCodigoPlu('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={3} lg={3}>
                                <TextField
                                    label="DESCRIÇÃO"
                                    disabled={loading}
                                    variant="outlined"
                                    value={descricao_completa}
                                    onChange={e => setDescricaoCompleta(e.target.value)}
                                    onClick={() => setDescricaoCompleta('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={2}>
                                <TextField
                                    label="SEÇÃO"
                                    disabled={loading}
                                    variant="outlined"
                                    value={descricao_secao}
                                    onChange={e => setSecao(e.target.value)}
                                    onClick={() => setSecao('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={2}>
                                <TextField
                                    label="GRUPO"
                                    disabled={loading}
                                    variant="outlined"
                                    value={descricao_grupo}
                                    onChange={e => setGrupo(e.target.value)}
                                    onClick={() => setGrupo('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={2}>
                                <TextField
                                    label="SUB GRUPO"
                                    disabled={loading}
                                    variant="outlined"
                                    value={descricao_sub_grupo}
                                    onChange={e => setSubGrupo(e.target.value)}
                                    onClick={() => setSubGrupo('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} style={{ marginBottom: 2 }}>
                                <Button
                                    sx={{
                                        borderRadius: '0px',
                                        border: '1px solid',
                                        margin: '0',
                                        width: '100%'
                                    }}
                                    disabled={loading}
                                    onClick={clearFilters}
                                >
                                    Limpar filtros
                                </Button>
                            </Grid>
                            <Grid item xs={6} style={{ marginBottom: 2 }}>
                                <Button
                                    sx={{
                                        borderRadius: '0px',
                                        border: '1px solid #1c2e4a',
                                        margin: '0',
                                        backgroundColor: primaryColor,
                                        color: 'white',
                                        width: '100%'
                                    }}
                                    disabled={loading}
                                    onClick={runFilters}
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Grid>
    );
}

export default EstruturaMercadologicaPageFilter;
